import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FormComponent } from './components/form/form.component';
import { NotFoundComponent } from './components/not-found/not-found.component';

const routes: Routes = [
    { path: '404', component: NotFoundComponent },
    {
        path: '',
        component: FormComponent,
    },
    {
        path: ':slug',
        component: FormComponent,
    },
    {
        path: ':slug/:token',
        component: FormComponent,
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
